var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "scp-actions-popup",
      class: { "is-collapsed": _vm.collapsed },
      style: _vm.popupStyle,
      attrs: { role: "dialog", "aria-labelledby": "scp-actions-title" },
    },
    [
      _c("div", { staticClass: "scp-actions-head" }, [
        _c(
          "span",
          {
            staticClass: "scp-actions-title",
            attrs: { id: "scp-actions-title" },
          },
          [_vm._v("Actions")]
        ),
        _c("div", { staticClass: "scp-actions-head-btns" }, [
          _c(
            "button",
            {
              staticClass: "scp-actions-icon-btn",
              attrs: {
                type: "button",
                "aria-label": _vm.collapsed
                  ? "Expand Actions panel"
                  : "Collapse Actions panel",
                "aria-expanded": _vm.collapsed ? "false" : "true",
                title: _vm.collapsed ? "Expand" : "Collapse",
              },
              on: {
                click: function ($event) {
                  _vm.collapsed = !_vm.collapsed
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "scp-actions-collapse-glyph",
                  attrs: { "aria-hidden": "true" },
                },
                [_vm._v(_vm._s(_vm.collapsed ? "▸" : "▾"))]
              ),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "scp-actions-icon-btn scp-actions-close",
              attrs: { type: "button", "aria-label": "Close", title: "Close" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v(" × ")]
          ),
        ]),
      ]),
      !_vm.collapsed
        ? [
            _c(
              "div",
              {
                staticClass: "scp-actions-tabs",
                attrs: { role: "tablist", "aria-label": "Actions sections" },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "scp-actions-tab",
                    class: { "is-active": _vm.activeTab === "next" },
                    attrs: {
                      type: "button",
                      role: "tab",
                      "aria-selected":
                        _vm.activeTab === "next" ? "true" : "false",
                    },
                    on: {
                      click: function ($event) {
                        _vm.activeTab = "next"
                      },
                    },
                  },
                  [_vm._v(" Next steps ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "scp-actions-tab",
                    class: { "is-active": _vm.activeTab === "catalog" },
                    attrs: {
                      type: "button",
                      role: "tab",
                      "aria-selected":
                        _vm.activeTab === "catalog" ? "true" : "false",
                    },
                    on: {
                      click: function ($event) {
                        _vm.activeTab = "catalog"
                      },
                    },
                  },
                  [_vm._v(" Actions ")]
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "scp-actions-list" },
              _vm._l(_vm.visibleActions, function (action) {
                return _c(
                  "button",
                  {
                    key: action.id,
                    staticClass: "scp-actions-item",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("run", action.id)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "scp-actions-item-label" }, [
                      _vm._v(_vm._s(action.label)),
                    ]),
                    _c("span", { staticClass: "scp-actions-item-desc" }, [
                      _vm._v(_vm._s(action.description)),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }